<script>
  import Button from "$lib/components/Button.svelte";
  import Link from "$lib/components/Link.svelte";
  import UtilityMenuItemSecondary from "$lib/components/MenuTypes/UtilityMenuItemSecondary.svelte";
  import UtilityMenuItemPrimary from "$lib/components/MenuTypes/UtilityMenuItemPrimary.svelte";
  import NavBrand from "$lib/components/NavBrand.svelte";

  let clazz;
  export { clazz as class };
  export let data;
  export let id;

  let _data = data?.fields
    ? { ...data.fields } /** inside rich text */
    : { ...data }; /** inside header/footer due to decoration */

  let TYPE_MAP = {
    primaryButton: Button,
    secondaryButton: Button,
    tertiaryButton: Button,
    ghostButton: Button,
    donateButton: Button,
    logoLink: NavBrand,
    utilityMenuPrimary: UtilityMenuItemPrimary,
    utilityMenuSecondary: UtilityMenuItemSecondary,
    productMenuLink: Button,
    viewAllLink: Link,
    fallback: Link
  };

  let PROPS_MAP = {
    primaryButton: {
      variant: "primary",
      size: _data.size,
      url: _data.destination?.fields.url
    },
    secondaryButton: {
      variant: "secondary",
      size: _data.size,
      url: _data.destination?.fields.url
    },
    tertiaryButton: {
      variant: "tertiary",
      size: _data.size,
      url: _data.destination?.fields.url
    },
    ghostButton: {
      variant: "ghost",
      size: _data.size,
      url: _data.destination?.fields.url
    },
    donateButton: {
      variant: "donate",
      size: _data.size,
      url: _data.destination?.fields.url
    },
    utilityMenuPrimary: {
      text: _data.text,
      url: _data.destination?.fields.url,
      class: `${clazz}`
    },
    utilityMenuSecondary: {
      url: _data.destination?.fields.url,
      text: _data.text,
      active: _data.active,
      class: `${clazz}`
    },
    productMenuLink: {
      variant: "productMenu",
      url: _data.destination?.fields.url,
      size: "header"
    },
    viewAllLink: {
      url: _data.destination?.fields.url,
      text: _data.text,
      class: `${clazz} !no-underline`
    },
    fallback: {
      url: _data.destination?.fields.url,
      text: _data.text,
      class: `${clazz} !no-underline`
    }
  };

  const type = _data.type || "fallback";

  let component = TYPE_MAP[type];

  const ICON_TYPE_MAP = {
    "Obama Foundation logo": "of",
    "Obama Foundation logo - dark": "of-dark"
  };

  function getProps(type) {
    let _props = PROPS_MAP[type] || {};
    if (_data.iconType) {
      _props.icon = {
        type: ICON_TYPE_MAP[_data.iconType] || _data.iconType,
        trailing: true,
        leading: false,
        size: "md"
      };
    }
    return _props;
  }

  $: props = getProps(type);
</script>

<!-- `embedded-content` should have no impact outside of rich text body -->
<div class="embedded-content">
  <svelte:component
    this={component}
    on:click
    on:urlDispatch
    data={_data}
    class={clazz}
    {...props}
    {id}
  >
    {#if _data.text}
      {_data.text}
    {:else}
      <slot />
    {/if}
  </svelte:component>
</div>
